import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 30V23.75H12V28H28V23.75H30V30H10Z",
			fill: "#1E1E1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.25 10L21.25 20.1875L24.5 16.9375L26.25 18.75L20 25L13.75 18.75L15.5 16.9375L18.75 20.1875L18.75 10L21.25 10Z",
			fill: "#1E1E1E"
		})
	]
});
export default SvgDownload;
